module.exports = __webpack_public_path__ + "static/Katas-9938af96531da600f56da77bbea36a7e.svg";